/* ============================================================
   DATZZY — cookie consent (GDPR / RODO) — Shopify Customer Privacy API
   ------------------------------------------------------------
   The DATZZY-branded banner + preferences modal are the ONLY consent UI. Consent is
   stored and managed by Shopify (window.Shopify.customerPrivacy): setTrackingConsent
   writes it, currentVisitorConsent reads it, shouldShowBanner decides when to show the
   banner. Shopify's own default banner is turned off in Admin → Customer privacy so it
   never duplicates ours (no CSS hiding, API stays enabled). We additionally mirror the
   choice into Google Consent Mode v2 (defaults denied in <head>) and Meta Pixel.

   Locale: text follows the active storefront language via window.dzConsentLocale
   (set from localization.language, so it is 'pl' on the Polish storefront regardless of
   the theme's default locale file). Copy + the privacy URL (/pages/polityka-prywatnosci)
   live in TEXTS below — never read from Shopify Admin.

   Categories: necessary (always on) · analytics (analytics_storage) ·
   marketing (ad_storage / ad_user_data / ad_personalization).
   Re-openable any time via the footer button → window.dzOpenConsent().
   ============================================================ */
(function(){
  var KEY = 'dz_consent_v1';
  var VERSION = 1;

  /* ---------- state ---------- */
  function read(){
    try { return JSON.parse(localStorage.getItem(KEY) || 'null'); } catch(e){ return null; }
  }
  function write(categories){
    var payload = { v: VERSION, ts: new Date().toISOString(), categories: categories };
    try { localStorage.setItem(KEY, JSON.stringify(payload)); } catch(e){}
    return payload;
  }

  /* ---------- Consent Mode v2 update ---------- */
  function applyConsent(c){
    window.dataLayer = window.dataLayer || [];
    if(typeof window.gtag !== 'function'){
      window.gtag = function(){ window.dataLayer.push(arguments); };
    }
    window.gtag('consent', 'update', {
      analytics_storage:     c.analytics ? 'granted' : 'denied',
      ad_storage:            c.marketing ? 'granted' : 'denied',
      ad_user_data:          c.marketing ? 'granted' : 'denied',
      ad_personalization:    c.marketing ? 'granted' : 'denied',
      personalization_storage: c.preferences ? 'granted' : 'denied',
      functionality_storage: 'granted'
    });
    // Custom event so GTM can fire consent-gated tags without a page reload.
    window.dataLayer.push({ event: 'dz_consent_update', dz_consent: c });
    // Meta Pixel (if present): grant/revoke on marketing consent.
    if(typeof window.fbq === 'function'){
      window.fbq('consent', c.marketing ? 'grant' : 'revoke');
    }
  }

  /* ---------- Shopify Customer Privacy API (source of truth) ---------- */
  /* Ensures window.Shopify.customerPrivacy is loaded, then runs cb(available). Loaded once. */
  var apiLoading = false, apiQueue = [];
  function withApi(cb){
    if(window.Shopify && window.Shopify.customerPrivacy && window.Shopify.customerPrivacy.setTrackingConsent){ cb(true); return; }
    apiQueue.push(cb);
    if(apiLoading) return;
    if(window.Shopify && typeof window.Shopify.loadFeatures === 'function'){
      apiLoading = true;
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function(err){
        apiLoading = false;
        var ok = !err && !!(window.Shopify && window.Shopify.customerPrivacy);
        var q = apiQueue.slice(); apiQueue = [];
        q.forEach(function(fn){ fn(ok); });
      });
    } else { var q2 = apiQueue.slice(); apiQueue = []; q2.forEach(function(fn){ fn(false); }); }
  }
  /* Persist the choice to Shopify (booleans), then run cb(success) after the callback. */
  function saveShopify(c, cb){
    withApi(function(ok){
      if(!ok){ if(cb) cb(false); return; }
      try{
        window.Shopify.customerPrivacy.setTrackingConsent({
          analytics:    !!c.analytics,
          marketing:    !!c.marketing,
          preferences:  !!c.preferences,
          sale_of_data: !!c.marketing
        }, function(result){ if(cb) cb(!(result && result.error)); });
      }catch(e){ if(cb) cb(false); }
    });
  }
  /* Reads the current consent from Shopify (source of truth), mapped to our categories. */
  function currentConsent(){
    try{
      var cp = window.Shopify.customerPrivacy;
      var c = cp.currentVisitorConsent ? cp.currentVisitorConsent() : null;
      if(c) return { necessary: true, preferences: c.preferences === 'yes', marketing: c.marketing === 'yes', analytics: c.analytics === 'yes' };
    }catch(e){}
    return null;
  }
  /* True once the visitor has made an explicit choice (accept OR reject) — any category
     is 'yes' or 'no' rather than '' (undecided). Once decided, the banner never returns. */
  function hasDecision(){
    try{
      var c = window.Shopify.customerPrivacy.currentVisitorConsent();
      return !!(c && (c.analytics || c.marketing || c.preferences || c.sale_of_data));
    }catch(e){ return false; }
  }

  /* ---------- styles (scoped, injected once) ---------- */
  var CSS = ''
  + '.dz-cc,.dz-cc *{box-sizing:border-box}'
  + '.dz-cc{position:fixed;left:0;right:0;bottom:0;z-index:9000;padding:0 var(--gutter,20px) 20px;'
  + 'display:flex;justify-content:center;pointer-events:none}'
  + '.dz-cc[hidden]{display:none}'
  + '.dz-cc-card{pointer-events:auto;width:100%;max-width:1100px;background:#fff;color:var(--ink,#12121c);'
  + 'border:1px solid var(--line,#e6e8ec);border-radius:var(--r-lg,18px);box-shadow:0 26px 70px -30px rgba(0,0,0,.45);'
  + 'padding:22px 24px;display:flex;align-items:center;gap:24px;flex-wrap:wrap}'
  + '.dz-cc-txt{flex:1 1 380px;min-width:0}'
  + '.dz-cc-txt h2{font-size:16px;font-weight:600;margin:0 0 6px;letter-spacing:-.01em;color:var(--ink,#12121c)}'
  + '.dz-cc-txt p{font-size:13.5px;line-height:1.6;color:var(--text-soft,#56556a);margin:0}'
  + '.dz-cc-txt a{color:var(--accent-deep,#0b8bb8);text-decoration:underline}'
  + '.dz-cc-actions{display:flex;gap:10px;flex-wrap:wrap;flex:0 0 auto}'
  + '.dz-cc-btn{font-family:inherit;font-size:13.5px;font-weight:600;line-height:1;cursor:pointer;'
  + 'border-radius:var(--r-pill,999px);padding:13px 20px;border:1.5px solid transparent;transition:background .15s,color .15s,border-color .15s}'
  + '.dz-cc-btn:focus-visible{outline:2px solid var(--accent,#0EAFE6);outline-offset:2px}'
  + '.dz-cc-primary{background:var(--accent,#0EAFE6);color:#fff}'
  + '.dz-cc-primary:hover{background:var(--accent-deep,#0b8bb8)}'
  + '.dz-cc-ghost{background:#fff;color:var(--ink,#12121c);border-color:var(--line-2,#d4d7de)}'
  + '.dz-cc-ghost:hover{border-color:var(--ink,#12121c)}'
  + '.dz-cc-link{background:none;border:none;color:var(--text-soft,#56556a);text-decoration:underline;padding:13px 6px}'
  + '.dz-cc-link:hover{color:var(--ink,#12121c)}'
  /* modal */
  + '.dz-cc-modal{position:fixed;inset:0;z-index:9100;display:flex;align-items:center;justify-content:center;padding:20px}'
  + '.dz-cc-modal[hidden]{display:none}'
  + '.dz-cc-scrim{position:absolute;inset:0;background:rgba(12,11,22,.55);backdrop-filter:blur(2px)}'
  + '.dz-cc-panel{position:relative;background:#fff;border-radius:var(--r-lg,18px);max-width:560px;width:100%;'
  + 'max-height:86vh;overflow:auto;padding:28px;box-shadow:0 30px 80px -30px rgba(0,0,0,.6)}'
  + '.dz-cc-panel h2{font-size:20px;font-weight:600;margin:0 0 8px;letter-spacing:-.01em}'
  + '.dz-cc-panel>p{font-size:14px;color:var(--text-soft,#56556a);line-height:1.6;margin:0 0 20px}'
  + '.dz-cc-opt{display:flex;gap:14px;align-items:flex-start;padding:16px 0;border-top:1px solid var(--line,#e6e8ec)}'
  + '.dz-cc-opt b{display:block;font-size:14.5px;font-weight:600;margin-bottom:4px}'
  + '.dz-cc-opt span{display:block;font-size:13px;color:var(--text-soft,#56556a);line-height:1.55}'
  + '.dz-cc-opt input{width:18px;height:18px;margin-top:2px;flex:0 0 auto;accent-color:var(--accent,#0EAFE6);cursor:pointer}'
  + '.dz-cc-opt input:disabled{cursor:not-allowed;opacity:.6}'
  + '.dz-cc-foot{display:flex;gap:10px;flex-wrap:wrap;margin-top:22px}'
  + '@media(max-width:760px){'
  + '.dz-cc{padding:0 12px 12px}.dz-cc-card{padding:18px;gap:16px}'
  + '.dz-cc-actions{width:100%}.dz-cc-btn{flex:1 1 auto;text-align:center}'
  + '.dz-cc-panel{padding:22px}}'
  + '@media(prefers-reduced-motion:no-preference){.dz-cc-card{animation:dzCcIn .32s cubic-bezier(.22,1,.36,1) both}'
  + '@keyframes dzCcIn{from{opacity:0;transform:translateY(14px)}to{opacity:1;transform:none}}}';

  function injectCSS(){
    if(document.getElementById('dz-cc-style')) return;
    var s = document.createElement('style');
    s.id = 'dz-cc-style';
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  /* ---------- copy — follows the active storefront locale (window.dzConsentLocale) ----------
     Banner body embeds the privacy link mid-sentence: bodyPre + <a>policy</a> + bodyEnd.
     Four consent categories map to Shopify Customer Privacy: preferences / marketing /
     analytics (+ always-on necessary). The privacy URL lives here (not read from Admin). */
  var TEXTS = {
    pl: {
      title: 'Szanujemy Twoją prywatność',
      bodyPre: 'Używamy plików cookie, aby zapewnić prawidłowe działanie sklepu, analizować ruch oraz – za Twoją zgodą – dostosowywać treści i działania marketingowe. Więcej informacji znajdziesz w naszej ',
      policy: 'Polityce prywatności',
      bodyEnd: '.',
      privacyUrl: '/pages/polityka-prywatnosci',
      custom: 'Ustawienia cookies', reject: 'Odrzuć opcjonalne', accept: 'Akceptuj wszystkie',
      mTitle: 'Ustawienia plików cookie',
      mIntro: 'Masz kontrolę nad swoimi danymi. Wybierz, na które kategorie plików cookie wyrażasz zgodę. Możesz zmienić tę decyzję w dowolnym momencie.',
      acceptAll: 'Akceptuj wszystkie', rejectAll: 'Odrzuć wszystkie', save: 'Zapisz wybór',
      cats: {
        necessary:   { name: 'Niezbędne',     desc: 'Konieczne do prawidłowego działania sklepu, nawigacji, koszyka i bezpieczeństwa. Zawsze aktywne.' },
        preferences: { name: 'Personalizacja', desc: 'Zapamiętują Twoje preferencje (np. język i region), aby dopasować sposób wyświetlania sklepu.' },
        marketing:   { name: 'Marketing',      desc: 'Pozwalają dopasować przekaz reklamowy i mierzyć skuteczność kampanii.' },
        analytics:   { name: 'Analityka',      desc: 'Pomagają nam zrozumieć, jak korzystasz ze sklepu, abyśmy mogli go ulepszać.' }
      }
    },
    en: {
      title: 'We respect your privacy',
      bodyPre: 'We use cookies to run the store, analyse traffic and — with your consent — personalise content and marketing. Learn more in our ',
      policy: 'Privacy Policy',
      bodyEnd: '.',
      privacyUrl: '/pages/polityka-prywatnosci',
      custom: 'Cookie settings', reject: 'Reject optional', accept: 'Accept all',
      mTitle: 'Cookie settings',
      mIntro: 'You are in control of your data. Choose which cookie categories you consent to. You can change this at any time.',
      acceptAll: 'Accept all', rejectAll: 'Reject all', save: 'Save choice',
      cats: {
        necessary:   { name: 'Necessary',       desc: 'Required for the store to work, navigation, cart and security. Always on.' },
        preferences: { name: 'Personalisation', desc: 'Remember your preferences (e.g. language and region) to tailor how the store is shown.' },
        marketing:   { name: 'Marketing',       desc: 'Allow tailored advertising and measuring campaign effectiveness.' },
        analytics:   { name: 'Analytics',       desc: 'Help us understand how you use the store so we can improve it.' }
      }
    },
    de: {
      title: 'Wir respektieren Ihre Privatsphäre',
      bodyPre: 'Wir verwenden Cookies für den Betrieb des Shops, zur Analyse und — mit Ihrer Einwilligung — zur Personalisierung von Inhalten und Marketing. Mehr in unserer ',
      policy: 'Datenschutzerklärung',
      bodyEnd: '.',
      privacyUrl: '/pages/polityka-prywatnosci',
      custom: 'Cookie-Einstellungen', reject: 'Optionale ablehnen', accept: 'Alle akzeptieren',
      mTitle: 'Cookie-Einstellungen',
      mIntro: 'Sie haben die Kontrolle über Ihre Daten. Wählen Sie, welchen Cookie-Kategorien Sie zustimmen. Sie können dies jederzeit ändern.',
      acceptAll: 'Alle akzeptieren', rejectAll: 'Alle ablehnen', save: 'Auswahl speichern',
      cats: {
        necessary:   { name: 'Notwendig',        desc: 'Erforderlich für Betrieb, Navigation, Warenkorb und Sicherheit. Immer aktiv.' },
        preferences: { name: 'Personalisierung', desc: 'Speichern Ihre Präferenzen (z. B. Sprache und Region), um den Shop anzupassen.' },
        marketing:   { name: 'Marketing',        desc: 'Ermöglichen personalisierte Werbung und die Erfolgsmessung von Kampagnen.' },
        analytics:   { name: 'Analyse',          desc: 'Helfen zu verstehen, wie Sie den Shop nutzen, um ihn zu verbessern.' }
      }
    }
  };
  // Normalise e.g. 'pl-PL' → 'pl'. TEXTS[locale] with PL as the temporary launch fallback
  // (only used if the storefront locale is not one of the supported TEXTS).
  var LOCALE = String(window.dzConsentLocale || '').toLowerCase().split('-')[0];
  var T = TEXTS[LOCALE] || TEXTS.pl;
  var PRIVACY_URL = T.privacyUrl;

  /* ---------- banner ---------- */
  var banner, modal, lastFocus;

  function buildBanner(){
    banner = document.createElement('div');
    banner.className = 'dz-cc';
    banner.setAttribute('role', 'dialog');
    banner.setAttribute('aria-live', 'polite');
    banner.setAttribute('aria-label', T.title);
    banner.hidden = true;
    banner.innerHTML =
      '<div class="dz-cc-card">' +
        '<div class="dz-cc-txt">' +
          '<h2>' + T.title + '</h2>' +
          '<p>' + T.bodyPre + '<a href="' + PRIVACY_URL + '" rel="nofollow">' + T.policy + '</a>' + T.bodyEnd + '</p>' +
        '</div>' +
        '<div class="dz-cc-actions">' +
          '<button type="button" class="dz-cc-btn dz-cc-link" data-cc="custom">' + T.custom + '</button>' +
          '<button type="button" class="dz-cc-btn dz-cc-ghost" data-cc="reject">' + T.reject + '</button>' +
          '<button type="button" class="dz-cc-btn dz-cc-primary" data-cc="accept">' + T.accept + '</button>' +
        '</div>' +
      '</div>';
    document.body.appendChild(banner);
    banner.addEventListener('click', function(e){
      var b = e.target.closest('[data-cc]'); if(!b) return;
      var a = b.getAttribute('data-cc');
      if(a === 'accept') decide({necessary:true, preferences:true, marketing:true, analytics:true});
      else if(a === 'reject') decide({necessary:true, preferences:false, marketing:false, analytics:false});
      else openModal();
    });
  }

  function buildModal(){
    modal = document.createElement('div');
    modal.className = 'dz-cc-modal';
    modal.hidden = true;
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-labelledby', 'dz-cc-mt');
    var C = T.cats;
    modal.innerHTML =
      '<div class="dz-cc-scrim" data-cc-close></div>' +
      '<div class="dz-cc-panel">' +
        '<h2 id="dz-cc-mt">' + T.mTitle + '</h2>' +
        '<p>' + T.mIntro + '</p>' +
        '<div class="dz-cc-opt"><input type="checkbox" id="dz-cc-n" checked disabled/>' +
          '<label for="dz-cc-n"><b>' + C.necessary.name + '</b><span>' + C.necessary.desc + '</span></label></div>' +
        '<div class="dz-cc-opt"><input type="checkbox" id="dz-cc-p"/>' +
          '<label for="dz-cc-p"><b>' + C.preferences.name + '</b><span>' + C.preferences.desc + '</span></label></div>' +
        '<div class="dz-cc-opt"><input type="checkbox" id="dz-cc-m"/>' +
          '<label for="dz-cc-m"><b>' + C.marketing.name + '</b><span>' + C.marketing.desc + '</span></label></div>' +
        '<div class="dz-cc-opt"><input type="checkbox" id="dz-cc-a"/>' +
          '<label for="dz-cc-a"><b>' + C.analytics.name + '</b><span>' + C.analytics.desc + '</span></label></div>' +
        '<div class="dz-cc-foot">' +
          '<button type="button" class="dz-cc-btn dz-cc-primary" data-cc="acceptAll">' + T.acceptAll + '</button>' +
          '<button type="button" class="dz-cc-btn dz-cc-ghost" data-cc="rejectAll">' + T.rejectAll + '</button>' +
          '<button type="button" class="dz-cc-btn dz-cc-ghost" data-cc="save">' + T.save + '</button>' +
        '</div>' +
      '</div>';
    document.body.appendChild(modal);

    modal.addEventListener('click', function(e){
      if(e.target.hasAttribute('data-cc-close')) { closeModal(); return; }
      var b = e.target.closest('[data-cc]'); if(!b) return;
      var act = b.getAttribute('data-cc');
      // decide() persists to Shopify and closes the modal/banner in its callback.
      if(act === 'acceptAll'){ decide({ necessary:true, preferences:true, marketing:true, analytics:true }); return; }
      if(act === 'rejectAll'){ decide({ necessary:true, preferences:false, marketing:false, analytics:false }); return; }
      decide({
        necessary: true,
        preferences: modal.querySelector('#dz-cc-p').checked,
        marketing:   modal.querySelector('#dz-cc-m').checked,
        analytics:   modal.querySelector('#dz-cc-a').checked
      });
    });
    modal.addEventListener('keydown', function(e){
      if(e.key === 'Escape'){ closeModal(); return; }
      if(e.key !== 'Tab') return;
      // simple focus trap
      var f = modal.querySelectorAll('button:not([disabled]),input:not([disabled])');
      if(!f.length) return;
      var first = f[0], last = f[f.length-1];
      if(e.shiftKey && document.activeElement === first){ e.preventDefault(); last.focus(); }
      else if(!e.shiftKey && document.activeElement === last){ e.preventDefault(); first.focus(); }
    });
  }

  function openModal(){
    var c = currentConsent() || (read() || {}).categories || {necessary:true, preferences:false, marketing:false, analytics:false};
    modal.querySelector('#dz-cc-p').checked = !!c.preferences;
    modal.querySelector('#dz-cc-m').checked = !!c.marketing;
    modal.querySelector('#dz-cc-a').checked = !!c.analytics;
    lastFocus = document.activeElement;
    modal.hidden = false;
    var f = modal.querySelector('#dz-cc-p');
    if(f) f.focus();
  }
  function closeModal(){
    modal.hidden = true;
    if(lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function decide(categories){
    write(categories);          // Consent-Mode cache (localStorage, per-origin)
    applyConsent(categories);   // Google Consent Mode v2 + Meta Pixel mirror (immediate)
    // Persist to Shopify (source of truth) and only close once it has recorded the choice.
    saveShopify(categories, function(){
      if(banner) banner.hidden = true;
      if(modal && !modal.hidden) closeModal();
    });
  }

  /* ---------- public API: reopen preferences ---------- */
  window.dzOpenConsent = function(){
    if(!modal) return;
    if(banner) banner.hidden = true;
    openModal();
  };

  /* ---------- boot ----------
     Shopify's Customer Privacy API is the source of truth. We show the DATZZY banner
     ONLY when Shopify says consent should be collected (shouldShowBanner). This replaces
     Shopify's default banner UI (which the merchant turns off in Admin → Customer privacy)
     without disabling the API or hiding anything with CSS. If the API is unavailable, we
     fall back to the local Consent-Mode cache so the banner still works. */
  function init(){
    injectCSS();
    buildBanner();
    buildModal();
    // Decide AFTER the API is ready — never render-then-hide, never show if already decided.
    withApi(function(available){
      if(available){
        var c = currentConsent();
        if(c) applyConsent(c);                        // mirror stored Shopify consent → Consent Mode
        var show;
        if(hasDecision()){
          show = false;                               // visitor already chose → never show again
        } else {
          try { show = !!window.Shopify.customerPrivacy.shouldShowBanner(); }
          catch(e){ show = true; }
        }
        banner.hidden = !show;
      } else {
        // API unavailable → fall back to the per-origin cache so we don't nag on every page.
        var stored = read();
        if(stored && stored.categories){ applyConsent(stored.categories); banner.hidden = true; }
        else { banner.hidden = false; }
      }
    });
  }

  // Single init per page load (idempotent guard against a double include).
  if(!window.__dzConsentInit){
    window.__dzConsentInit = true;
    if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
  }
})();
